exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".member-header[data-v-5a30a771] {\n  padding: 0;\n}\n.member-header--has-payment[data-v-5a30a771] {\n  color: #daecec;\n}\n.member-header--has-payment > img[data-v-5a30a771] {\n  width: 24px;\n  margin-right: 6px;\n}\n.member-header--has-payment > span[data-v-5a30a771] {\n  position: relative;\n}", ""]);

// exports
